import { createStore } from 'redux';
import { Store as StoreType, Action as ActionType } from 'redux';
import { IReducers, IReducerStore } from '../reducers/ReducerWrapper';
import { _store } from './Store';

class _StoreContainer {
  private static _instance: _StoreContainer;

  private _store: StoreType<any, ActionType> | undefined;
  public set store(store) {
    if (!this._store) this._store = store || _store;
  }
  public get store(): StoreType<IReducers, ActionType> {
    return (
      (this._store as StoreType<IReducers, ActionType>) ||
      (this._store = _store as StoreType<IReducers, ActionType>)
    );
  }

  public static Instance(
    store?: StoreType<IReducers, ActionType>
  ): _StoreContainer {
    if (this._instance) return this._instance;
    this._instance = new this();
    if (store) {
      this._instance.store = store;
    }
    return this._instance;
  }

  // public static getState(): IReducers {
  //   return this._instance._store?.getState();
  // }
}
const StoreContainer = _StoreContainer.Instance();
export const Store = StoreContainer.store;
